<template>
  <LayoutDefault
    isShowHeader
    title="Достижения"
    isShowFooter
    customFooter
    visibleClose
  >
    <div class="progress">
      <div class="progress__editor">
        <div class="progress__editor-year">
          <p>Год:</p>
          <p class="progress__editor-disable">{{previousYear}}</p>
        </div>
        <div class="card flex justify-content-center"
        v-for="(item, i) of achievementsData"
        :key="i"
        >
          <span class="p-float-label">
            <InputNumber
              :id="item.TypeId"
              v-model="item.Value"
            />
            <label :for="item.TypeId">{{ item.TypeName }}</label>
          </span>
        </div>
      </div>

      <div class="progress__footer">
        <BaseBtn
          text="Сохранить"
          @clickBtn="saveBtn"
        />
        <BaseBtn
          text="Отменить"
          @clickBtn="resetBtn"
        />
      </div>
    </div>
    <template #customFooter>
      <div class="progress__footer">
        <BaseBtnNew
          name="Сохранить"
          @clickBtn="saveBtn"
        >
          <SaveIconNew/>
        </BaseBtnNew>
        <BaseBtnNew
          red
          name="Отменить"
          @clickBtn="resetBtn"
        >
        <CancelIcon/>
        </BaseBtnNew>
      </div>
    </template>
  </LayoutDefault>
</template>

<script>
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'

import LayoutDefault from '@/layout/LayoutDefault'

import InputNumber from 'primevue/inputnumber'
import BaseBtnNew from '@/components/ui/BaseBtnNew'
import CancelIcon from '@/components/icons/CancelIcon.vue'
import SaveIconNew from '@/components/icons/SaveIconNew.vue'

export default {
  name: 'AchievementsEditorView',
  components: {
    LayoutDefault,
    BaseBtnNew,
    InputNumber,
    CancelIcon,
    SaveIconNew
  },
  props: {
  },
  setup () {
    const store = useStore()

    onMounted(() => {
      store.dispatch('setAchievementsData')
    })

    const achievementsData = computed(() => {
      return store.getters.getAchievementsData
    })

    const previousYear = computed(() => {
      const currentYear = new Date().getFullYear()
      return currentYear - 1
    })

    const saveBtn = () => {
      store.dispatch('setChangeAchievementsData', achievementsData.value)
      store.commit('SetShowAchievementsEditor', false)
    }

    const resetBtn = () => {
      store.dispatch('setAchievementsData')
    }

    return {
      achievementsData,
      saveBtn,
      resetBtn,
      previousYear
    }
  }
}
</script>

<style lang="scss" scoped>
.progress {
  margin-top: 12px;
  &__editor {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 40px;
    width: 800px;
    text-align: left;

    &-year {
      font-weight: 500;
      font-size: 18px;
      line-height: 1.8;
    }

    &-disable {
      color: #00000059;
      font-weight: 400;
      font-size: 16px;
    }
  }

  &__footer {
    display: flex;
    justify-content: center;
    gap: 12px;
  }
}
.card {
  width: 100%;
}
:deep(.p-float-label) {
  label {
    align-self: start;
    font-weight: 500;
    font-size: 18px !important;
    color: #000000;
    margin-bottom: 10px !important;
  }
}
:deep(.base-button) {
  width: 200px;
}
:deep(.footer) {
  justify-content: flex-end !important;
}

:deep(.p-inputtext) {
  border: 1px solid #000000;
  // -webkit-box-shadow: inset 0 0 0 50px white;
}

:deep(.p-inputtext:enabled:hover) {
  border-color: #00ABEC;
}
:deep(.p-inputtext:disabled) {
  opacity: 0.5;
}

:deep(.p-inputtext:enabled:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.1rem #00ABEC;
  border-color: #00ABEC;
  -webkit-box-shadow: inset 0 0 0 50px white;
}
:deep(.p-inputnumber) {
  width: 100%;
  max-width: 800px;
}
</style>
